import { create } from 'zustand';
import { connectivity } from '@/services/connectivity';

interface ConnectionState {
  online: boolean;
  set: (online: boolean) => void;
}

export const useConnectionStore = create<ConnectionState>((set) => ({
  online: connectivity.online,
  set: (online) => set({ online }),
}));

connectivity.subscribe((online) => {
  useConnectionStore.getState().set(online);
});
